import React, { useEffect, useState } from "react";
import {
  Button,
  Group,
  IconPlaceholder,
  TableInterface,
  Modal,
  Table,
  TextBox,
  Search,
  IconInfo,
  Select,
} from "@veneer/core";
import { Col, Container, Row } from "react-bootstrap";
import "./Product-warranty-modal.css";
import { apiPost } from "../../../../services/service";
import {
  POST_ADDPRODUCT_WARRANTY,
  POST_btnProductSearch_Click,
} from "../../../../services";
import { HpLogo } from "../../shared-components/hp-logo/hp-logo";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import CustomTable from "@components/shared-components/custom-table/custom-table";

interface ModalProps {
  show: boolean;
  siteAccount: any[];
  relaodtable: () => void;
  onClose: () => void;
}

const Product_warranty_modal: React.FC<ModalProps> = ({
  show,
  onClose,
  siteAccount,
  relaodtable,
}) => {
  const { t } = useTranslation();
  const individualOrCompany: boolean =
    (window as any).IsIndividualRole || false;
  const columns = [
    {
      id: "AssestSerialNumber",
      label: t("HPI.ContractWarranties.TabSerialNumber", {
        defaultValue: "Serial Number",
      }),
    },
    {
      id: "AssetProductNumber",
      label: t("HPI.ContractWarranties.TabProductNumber", {
        defaultValue: "Product Number",
      }),
    },
    {
      id: "EntitlementType",
      label: t("HPI.ContractWarranties.TabEntitlementType", {
        defaultValue: "Entitlement Type",
      }),
    },
  ];
  const [open, setOpen] = React.useState(false);
  const [serialNumber, setSerialNumber] = React.useState("");
  const [productNumber, setProductNumber] = React.useState("");
  const [error, setError] = useState<any>(false);
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [showTable, setShowTable] = useState(false);
  const [lblMessageProduct, setlblMessageProduct] = useState("");
  const [lblEntitlementMessage, setlblEntitlementMessage] = useState("");
  const [lblEntitlementDetails, setlblEntitlementDetails] = useState("");
  const [showAddProductBtn, setShowAddProductBtn] = useState(false);
  const [siteCompanyOption, setSiteCompanyOption] = useState<any>([]);
  const [company, setCompany] = useState("");
  const [selectedRow, setSelectedRow] = useState<any | null>(null);
  const [addProductDisabled, setAddProductDisabled] = React.useState(false);
  const [disabledSearch, setDisabledSearch] = React.useState(false);

  // setData(null)
  // setFilteredData(null)
  if (!show) return null;
  const handleSerialNumber = (
    value: string,
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setSerialNumber(value.trim());
  };
  const handleProductNumber = (
    value: string,
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setProductNumber(value);
  };

  // const clickOnRowItems = (item: any, name: any) => {
  //   return (
  //     // <button onClick={() => { navigate(`/create-case/submit?${uri}`) }}>{btnName}</button>
  //     <button
  //       className="selected-row"
  //       onClick={(e) => handleRowSelected(item, e)}
  //     >
  //       {name}
  //     </button>
  //   );
  // };

  // const handleRowSelected = (data: any, e: any) => {
  //   const parentDiv = e.target.closest("tr");
  //   const table = e.target.closest("table");
  //   if (table) {
  //     const rows = table.querySelectorAll("tr");
  //     for (let row of rows) {
  //       row.classList.remove("selectedRow");
  //     }
  //   }
  //   if (parentDiv) {
  //     parentDiv.classList.add("selectedRow");
  //   }
  //   setSelectedRow(data);
  // };
  const handleRowSelect = (data: any) => {
    setSelectedRow(data);
  };

  const handleSearch = async () => {
    setError("null");
    setDisabledSearch(true);
    try {
      // let payload = { "txtProductId": serialNumber, "txtProductNumber": productNumber, "hdnSelectedTab": "4", "contactid": "85680C15-7814-E711-80FC-5065F38AD971", "lcid": "1033", "datalang": "en-US" }
      let payload = {
        contactid: "85680C15-7814-E711-80FC-5065F38AD971",
        
        hdnSelectedTab: "4",
        
        txtProductId: serialNumber,
        txtProductNumber: productNumber,
      };
      const response = await apiPost(POST_btnProductSearch_Click, payload);
      if (response.data) {
        const gvEntitlementFound = JSON.parse(response.data.gvEntitlementFound);
        const lblMessageProduct = response.data.lblMessageProduct;
        const lblEntitlementMessage = response.data.lblEntitlementMessage;
        const lblEntitlementDetails = response.data.lblEntitlementDetails;
        const productAddContainer = response.data.productAddContainer;
        const productSearchContainer = response.data.productSearchContainer;
        setDisabledSearch(false);
        if (lblMessageProduct.length > 0) {
          setShowTable(false);
        } else {
          setShowTable(true);
        }
        if (productSearchContainer) {
          setShowAddProductBtn(true);
          let sitesubdropdown = siteAccount
            ? JSON.parse(siteAccount as any).map(({ Value, Key }: any) => ({
                label: Value,
                value: Key,
              }))
            : [];
          const staticAddress = { label: t('HPI.Dropdown.SelectSiteAccount',{defaultValue:'Select Site Account'}), value: "-1" };
          setSiteCompanyOption([staticAddress, ...sitesubdropdown]);
        } else {
          setShowAddProductBtn(false);
        }
        setlblMessageProduct(lblMessageProduct);
        setlblEntitlementMessage(lblEntitlementMessage);
        setlblEntitlementDetails(lblEntitlementDetails);
        const formattedData: any = JSON.parse(
          response.data.gvEntitlementFound
        ).map((item: any) => ({
          AssestSerialNumber: item.AssestSerialNumber,
          AssetProductNumber: item.AssetProductNumber,
          EntitlementType: item.EntitlementType,
        }));

        setData(formattedData);
        setFilteredData(formattedData);
      }
    } catch (err) {
      setDisabledSearch(false);
      setError("Failed ");
    }
  };

  const handleAddProduct = async () => {
    setAddProductDisabled(true);
    // if (company === "-1" || company === "") {
    //   toast.error("Please select dropdown");
    //   setAddProductDisabled(false);
    //   return false;
    // }
    // if (selectedRow === null) {
    //   toast.error("Please select any row from above table");
    //   setAddProductDisabled(false);
    //   return false;
    // }
    // {
    //     "ddlProductSiteAccount": "-1",
    //     "txtProductNumber": "8Y1P7AV",
    //     "hdnSelectedTab": "2",
    //     "hdnProductId": "5CG4515QJJ",
    //     "contactid": "85680C15-7814-E711-80FC-5065F38AD971",
    //     "lcid": "1033",
    //     "datalang": "en-US"
    // }
    let payload = {
      ddlProductSiteAccount: individualOrCompany !== true ? company : "-1",
      txtProductNumber: selectedRow?.AssetProductNumber,
      hdnSelectedTab: selectedRow?.EntitlementType === "Product" ? "4" : "2",
      hdnProductId: selectedRow?.AssestSerialNumber,
      contactid: "85680C15-7814-E711-80FC-5065F38AD971",
      
      
    };

    try {
      const addProduct = await apiPost(POST_ADDPRODUCT_WARRANTY, payload);
      if (addProduct.data) {
        onClose();
        // toast.success(
        //   addProduct.datalblMessageProduct === ""
        //     ? addProduct.datalblMessageProduct
        //     : "Product has been added"
        // );
        relaodtable();
        setAddProductDisabled(false);
      }
    } catch (error) {
      console.log(error);
      setAddProductDisabled(false);
    }
  };

  return (
    <div>
      <div style={{ position: "relative" }}>
        <Button onClick={() => setOpen(true)}>Open Modal</Button>
        <Modal
          align="center"
          closeButton
          id="modal-id"
          className="warranty-popup"
          show={show}
          onClose={onClose}
          header={
            <div className="popup-header">
              <HpLogo />
              <h4>
                {t("HPI.Contractwarranties.AddProductModal.AddProduct", {
                  defaultValue: "Add Product",
                })}
              </h4>
            </div>
          }
        >
          <Container>
            <Row>
              <Col lg={8}>
                <div className="textbox">
                  <TextBox
                    placeholder={t("HPI.Placeholder.CW.EnterSerialNumber", {
                      defaultValue:
                        "Enter Serial Number / CarePack ID (mandatory)",
                    })}
                    onChange={handleSerialNumber}
                  />
                  <p className="label-small">
                    <IconInfo size={20} filled color="#666" />
                    <span className="ex-text">
                      {t("HPI.Contractwarranties.AddProductModal.Snexample", {
                        defaultValue: "Example:JPCL91500B",
                      })}
                    </span>
                  </p>
                </div>
              </Col>
            </Row>
            <Row>
              <Col lg={8}>
                <div className="textbox">
                  <TextBox
                    placeholder={t("HPI.Placeholder.ProductNumber", {
                      defaultValue: "Enter Product Number",
                    })}
                    onChange={handleProductNumber}
                  />

                  <p className="label-small">
                    <IconInfo size={20} filled color="#666" />
                    <span className="ex-text">
                      {t(
                        "HPI.Contractwarranties.AddContractModal.ProductNumber",
                        { defaultValue: "Example: FABU567X" }
                      )}
                    </span>
                  </p>
                </div>
              </Col>
              <Col lg={4}>
                <Button disabled={disabledSearch} onClick={handleSearch}>
                  {t("HPI.ContractWarranties.btnSearchProduct", {
                    defaultValue: "Search Product",
                  })}
                </Button>
              </Col>
            </Row>

            <Row>
              {!lblMessageProduct ? (
                " "
              ) : (
                <>
                  <span style={{ color: "red" }}>{lblMessageProduct}</span>
                </>
              )}
              {lblMessageProduct ? (
                ""
              ) : (
                <>
                  <div className="text-left mb-3">
                    <span className="label-regular">
                      {lblEntitlementDetails}
                    </span>
                  </div>
                  {!showTable ? (
                    ""
                  ) : (
                    // <Table
                    //   columns={columns as any}
                    //   data={filteredData as any}
                    // />
                    <CustomTable
                      columns={columns}
                      data={filteredData}
                      onRowSelect={handleRowSelect}
                    />
                  )}
                  <br />
                  <div className="text-left">
                    <span className="label-regular error">
                      {lblEntitlementMessage}
                    </span>
                  </div>
                  {showAddProductBtn && (
                    <>
                      {!individualOrCompany && (
                        <Col md={9} className="d-flex mt-3">
                          <Select
                            defaultValue={["-1"]}
                            options={siteCompanyOption}
                            helperTextVisibility="auto"
                            placeholder={t('HPI.Dropdown.SelectSiteAccount',{defaultValue:'Select Site Account'})}
                            name="company"
                            onChange={(v) => {
                              setCompany(v.value);
                            }}
                          />
                        </Col>
                      )}
                      <Col md={3} className="mt-3">
                        <Button
                          onClick={handleAddProduct}
                          disabled={addProductDisabled}
                        >
                          {t(
                            "HPI.Contractwarranties.AddProductModal.AddProduct",
                            { defaultValue: "Add Product" }
                          )}
                        </Button>
                      </Col>
                    </>
                  )}
                </>
              )}
            </Row>
          </Container>
        </Modal>
      </div>
    </div>
  );
};

export default Product_warranty_modal;
